module.exports = __webpack_public_path__ + "img/icon-y.3a0a8c4d.svg";